export default __webpack_public_path__ + "static/media/avatarImage.561f36eb.jpeg";